import accounting from 'accounting'

const NumberAmount = (number: number) => {
    return accounting.formatMoney(number, {
        symbol: '',
    })
}

export default NumberAmount
